import { lazy } from 'react';

const help = lazy(() => import('./Help'));

export { help };
